export { default as hyundai } from './hyundai.svg';
export { default as ra } from './ra.svg';
export { default as uol } from './uol.svg';
export { default as tim } from './tim.svg';
export { default as merlin } from './leroymerlin.svg';
export { default as olx } from './olx.svg';
